// src/analytics.js

// Keep a cached reference to the initialization promise
let gaInitPromise = null;

/**
 * Dynamically fetches and initializes GA4 on demand.
 * Ensures the 94 KiB library is only downloaded once.
 */
export const initGA = () => {
  if (typeof window === 'undefined' || process.env.NODE_ENV !== 'production') {
    return Promise.resolve(null);
  }

  // If initialization has already started or finished, return the existing promise
  if (!gaInitPromise) {
    gaInitPromise = import('react-ga4')
      .then(({ default: ReactGA }) => {
        ReactGA.initialize('G-B495LM3VSG', {
          debug: false,
          titleCase: false,
          gaOptions: {
            userId: 123,
            siteSpeedSampleRate: 50,
          },
        });
        return ReactGA;
      })
      .catch((err) => {
        console.error('Failed to load Google Analytics', err);
        return null;
      });
  }

  return gaInitPromise;
};

/**
 * Safely logs a page view after ensuring GA is fully initialized.
 */
export const logPageView = async () => {
  const ReactGA = await initGA();
  if (ReactGA) {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
    });
  }
};